import { Instagram, Mail } from "lucide-react";
import { SITE } from "../lib/site";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.5a8.16 8.16 0 0 0 4.77 1.52V6.65a4.85 4.85 0 0 1-1.84-.04z" />
  </svg>
);

const EtsyIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M9.16 5.5v5.74h2.85c.46 0 .8-.03.99-.1.2-.06.36-.2.49-.42.13-.21.23-.55.31-1.02h.43v4.55h-.43c-.08-.45-.18-.79-.31-1.01-.13-.22-.29-.36-.49-.42-.2-.07-.53-.1-.99-.1H9.16v4.79c0 .62.04 1.02.13 1.18.09.16.27.27.55.32.27.05.85.07 1.74.07h1.06c1.21 0 2.09-.07 2.65-.22.55-.15 1.07-.51 1.55-1.09.49-.58.97-1.49 1.46-2.74h.5l-.74 4.97H5V19.5h.95c.69 0 1.16-.07 1.4-.21.24-.14.41-.35.5-.63.09-.28.13-.91.13-1.89V7.23c0-.97-.04-1.6-.13-1.88a1.07 1.07 0 0 0-.5-.64C7.11 4.57 6.64 4.5 5.95 4.5H5v-1h13.84l.18 4.4h-.46c-.27-1.09-.59-1.86-.94-2.31-.36-.46-.83-.77-1.41-.95-.58-.18-1.47-.27-2.66-.27H9.16z" />
  </svg>
);

const social = [
  { name: "Instagram", href: SITE.social.instagram, Icon: Instagram, testid: "social-instagram" },
  { name: "TikTok", href: SITE.social.tiktok, Icon: TikTokIcon, testid: "social-tiktok" },
  { name: "Etsy", href: SITE.social.etsy, Icon: EtsyIcon, testid: "social-etsy" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#050505] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-10">
        {/* Massive wordmark */}
        <div className="border-b border-white/10 pb-8">
          <h2 className="font-display uppercase text-white leading-[0.85] tracking-tighter text-[18vw] md:text-[14vw] lg:text-[11vw] select-none">
            iza3nee <span className="text-[#FF2222]">creations</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-12 gap-10 py-12">
          <div className="md:col-span-5">
            <p className="text-white/60 max-w-md leading-relaxed">
              Custom apparel & DTF printing crafted in <span className="text-white">Centreville, Virginia</span>.
              Spirit wear, statement tees, and one-of-one drops.
            </p>
            <a
              data-testid="footer-email-link"
              href={`mailto:${SITE.email}`}
              className="mt-5 inline-flex items-center gap-2 text-white hover:text-[#FF2222] transition-colors"
            >
              <Mail size={16} /> {SITE.email}
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-4">Explore</div>
            <ul className="space-y-2">
              {SITE.nav.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => document.getElementById(n.id)?.scrollIntoView({ behavior: "smooth" })}
                    className="text-white/80 hover:text-[#FF2222] uppercase tracking-wider text-sm"
                    data-testid={`footer-nav-${n.id}`}
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-4">Follow</div>
            <div className="flex flex-wrap gap-3">
              {social.map((s) => (
                <a
                  key={s.name}
                  data-testid={s.testid}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="group border border-white/15 hover:border-[#FF2222] hover:bg-[#FF2222] p-3 transition-all flex items-center gap-3"
                >
                  <s.Icon className="w-5 h-5 text-white" />
                  <span className="uppercase tracking-[0.2em] text-xs text-white">{s.name}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-wrap items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} iza3nee Creations · Centreville, VA</div>
          <div className="uppercase tracking-[0.25em]">Custom Apparel · DTF Printing</div>
        </div>
      </div>
    </footer>
  );
};
